import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import database from '../../system/model/firebase/firebase';
import { onChangeLoad } from '../reducer/loadReducer';
import { bodyEmail, PasswordGenerator } from '../../system/utils/mailHelper';

export const companyTypes = {
  FETCH_DATA: 'company/GETTING_DATA',
  PUBLISH_DATA: 'company/PUBLISHING_DATA',
  EDIT_DATA: 'company/EDIT_DATA',
  GET_USERS: 'company/GET_USERS_DATA',
  NEW_USER: 'company/NEW_USER',
  EDIT_USER: 'company/EDIT_USER',
  DELETE_USER: 'company/DELETE_USER',
  GETEMAIL: 'company/GETEMAIL',
};

export const loadUsers = (users) => ({
  type: companyTypes.GET_USERS,
  users,
});
// metodo que obtiene a los usuario que se encuentrar registrados en dicha empresa
export const getCompanyUsers = (companyID) => {
  return (dispatch, getState) => {
    return database
      .collection(getState().platform.platformName)
      .doc('data')
      .collection('companiesUsers')
      .get()
      .then((snapshot) => {
        const users = [];
        snapshot.forEach((doc) => {
          if (doc.data().objectID === companyID) {
            users.push(doc.data());
          }
        });
        dispatch(loadUsers(users));
      })
      .catch((err) => console.error(err));
  };
};

// Metodo que obtiene las plantillas de los 3 correos principales
// los cuales se utilizan de manera casi unica

export const getTemplateEmail = () => async (dispatch, getState) => {
  try {
    const { uid } = getState().auth;
    const { platformName } = getState().platform;
    const dataDB = await database
      .collection(`${platformName}/data/companies/`)
      .doc(uid)
      .collection('Format_Email')
      .get();
    const arrayDB = [];

    dataDB.docs.map((doc) => {
      arrayDB.push({
        objectID: doc.id,
        ...doc.data(),
      });
      return null;
    });
    // if (arrayDB.length) {
    dispatch({
      type: companyTypes.GETEMAIL,
      payload: [
        arrayDB?.EmailRe || {
          subject: '{CANDIDATE} tenemos noticias sobre tu proceso para {VACANCY}',
          ObjectId: 'EmailRe',
          objectID: 'EmailRe',
          body: '<p>Hola&nbsp; <em>{CANDIDATE}, </em>¿Cómo estás?</p><p><br></p><p><br></p><p>Quiero agradecerte el tiempo y la dedicación que mostraste en el proceso para la vacante de <em>{VACANCY}. </em>Valoro la disposición que tuviste con nosotros.</p><p>En esta ocasión <em>{COMPANY}</em>, ha decidido ir por otro camino. Si tienes alguna duda o quieres conocer el feedback de tu proceso responde este mail y te la haremos llegar.</p><p>&nbsp;</p><p class="ql-align-center">En <em>lapieza.io</em> buscamos encontrar el match perfecto de habilidades, conocimientos y fit-cultura entre postulantes y compañías.&nbsp</p><p><br></p>',
          logoMain:
            'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/company_logos%2F447de3ae-bdac-469a-b725-10ac9834fe62.jpg?alt=media&token=07ad63d7-768c-4b32-8f29-aae35b9616ff',
        },
        arrayDB?.EmailAc || {
          subject: '{CANDIDATE}  tenemos buenas noticias sobre tu aplicación para {COMPANY} /{VACANCY}',
          ObjectId: 'EmailAc',
          objectID: 'EmailAc',
          body: '<p>Quiero agradecerte el tiempo y la dedicación que mostraste en el proceso para la vacante de {VACANCY}. Valoro la disposición que tuviste con nosotros.</p><p>&nbsp;</p><p>Todo este esfuerzo se ha visto reflejado y me da gusto contarte que has sido aceptado, me pondré en contacto en el transcurso de la semana para darte más información.</p><p>&nbsp;</p><p>No dudes en contactarme si tienes alguna duda o comentario.</p><p>&nbsp;</p><p>¡Felicidades y te deseo mucho éxito!</p><p>Nos vemos pronto</p>',
          logoMain:
            'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/company_logos%2F447de3ae-bdac-469a-b725-10ac9834fe62.jpg?alt=media&token=07ad63d7-768c-4b32-8f29-aae35b9616ff',
        },
        arrayDB?.EmailPr || {
          subject: '{CANDIDATE} ¿Quieres saber cómo va tu proceso de selección para {VACANCY}?',
          ObjectId: 'EmailPr',
          objectID: 'EmailPr',
          body: '<p>Hola&nbsp;<em>{CANDIDATE}, </em>¿Cómo estás?</p><p><br></p><p>Sabemos que has invertido tiempo y dedicación para la vacante de <em>{VACANCY}. </em>Valoro la disposición que has tenido.Seguimos en el proceso de selección y tu perfil aún sigue activo, en los siguientes días recibirás más noticias.&nbsp</p><p><br></p>',
          logoMain:
            'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/company_logos%2F447de3ae-bdac-469a-b725-10ac9834fe62.jpg?alt=media&token=07ad63d7-768c-4b32-8f29-aae35b9616ff',
        },
      ],
    });
    // } else {
    //   dispatch({
    //     type: companyTypes.GETEMAIL,
    //     payload: [
    //       {
    //         subject: '{CANDIDATE} tenemos noticias sobre tu proceso para {VACANCY}',
    //         ObjectId: 'EmailRe',
    //         objectID: 'EmailRe',
    //         body: '<p>Hola&nbsp; <em>{CANDIDATE}, </em>¿Cómo estás?</p><p><br></p><p><br></p><p>Quiero agradecerte el tiempo y la dedicación que mostraste en el proceso para la vacante de <em>{VACANCY}. </em>Valoro la disposición que tuviste con nosotros.</p><p>En esta ocasión <em>{COMPANY}</em>, ha decidido ir por otro camino. Si tienes alguna duda o quieres conocer el feedback de tu proceso responde este mail y te la haremos llegar.</p><p>&nbsp;</p><p class="ql-align-center">En <em>lapieza.io</em> buscamos encontrar el match perfecto de habilidades, conocimientos y fit-cultura entre postulantes y compañías.&nbsp</p><p><br></p>',
    //         logoMain:
    //           'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/company_logos%2F447de3ae-bdac-469a-b725-10ac9834fe62.jpg?alt=media&token=07ad63d7-768c-4b32-8f29-aae35b9616ff',
    //       },
    //       {
    //         subject: '{CANDIDATE}  tenemos buenas noticias sobre tu aplicación para {COMPANY} /{VACANCY}',
    //         ObjectId: 'EmailAc',
    //         objectID: 'EmailAc',
    //         body: '<p>Quiero agradecerte el tiempo y la dedicación que mostraste en el proceso para la vacante de {VACANCY}. Valoro la disposición que tuviste con nosotros.</p><p>&nbsp;</p><p>Todo este esfuerzo se ha visto reflejado y me da gusto contarte que has sido aceptado, me pondré en contacto en el transcurso de la semana para darte más información.</p><p>&nbsp;</p><p>No dudes en contactarme si tienes alguna duda o comentario.</p><p>&nbsp;</p><p>¡Felicidades y te deseo mucho éxito!</p><p>Nos vemos pronto</p>',
    //         logoMain:
    //           'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/company_logos%2F447de3ae-bdac-469a-b725-10ac9834fe62.jpg?alt=media&token=07ad63d7-768c-4b32-8f29-aae35b9616ff',
    //       },
    //       {
    //         subject: '{CANDIDATE} ¿Quieres saber cómo va tu proceso de selección para {VACANCY}?',
    //         ObjectId: 'EmailPr',
    //         objectID: 'EmailPr',
    //         body: '<p>Hola&nbsp;<em>{CANDIDATE}, </em>¿Cómo estás?</p><p><br></p><p>Sabemos que has invertido tiempo y dedicación para la vacante de <em>{VACANCY}. </em>Valoro la disposición que has tenido.Seguimos en el proceso de selección y tu perfil aún sigue activo, en los siguientes días recibirás más noticias.&nbsp</p><p><br></p>',
    //         logoMain:
    //           'https://firebasestorage.googleapis.com/v0/b/pieza-development.appspot.com/o/company_logos%2F447de3ae-bdac-469a-b725-10ac9834fe62.jpg?alt=media&token=07ad63d7-768c-4b32-8f29-aae35b9616ff',
    //       },
    //     ],
    //   });
    // }
  } catch (e) {
    console.error(e);
  }
};

// este metodo actualiza en la base de datos de firebase.
// actualiza la informacion que se guarda en raiz de la empresa,
// se pasa directamente la varible payload y actualiza redux de igualmanera
export const updateCompany = (payload) => async (dispatch, getState) => {
  try {
    dispatch(onChangeLoad(false));
    const { uid } = getState().auth;
    const { platformName } = getState().platform;
    try {
      await database.collection(`${platformName}/data/companies/`).doc(uid).update(payload);
    } catch {
      await database.collection(`${platformName}/data/companies/`).doc(uid).set(payload);
    }
    dispatch({
      type: companyTypes.EDIT_DATA,
      payload,
    });
    NotificationManager.success('Datos de la empresa actualizados.');
    setTimeout(() => dispatch(onChangeLoad(true)), 2000);
  } catch (e) {
    console.error(e);
  }
};
// Metodo para actualizar el email, actualiza en la base de datos y en local

export const updateEmailTemplate =
  (payload = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch(onChangeLoad(false));
      const { uid } = getState().auth;
      const { platformName } = getState().platform;
      const { EmailTemplate } = getState().company;
      const { objectID } = payload;
      const filterData = EmailTemplate.reduce((acc, element) => {
        if (element.objectID === objectID) {
          acc.push(payload);
          return acc;
        }
        acc.push(element);
        return acc;
      }, []);
      const arrayTemplate = filterData;
      // Actualizamos la plantilla en Firebase
      try {
        await database
          .collection(`${platformName}/data/companies/`)
          .doc(uid)
          .collection('Format_Email')
          .doc(objectID)
          .update(payload);
      } catch (e) {
        await database
          .collection(`${platformName}/data/companies/`)
          .doc(uid)
          .collection('Format_Email')
          .doc(objectID)
          .set(payload);
      }

      dispatch({
        type: companyTypes.GETEMAIL,
        payload: arrayTemplate,
      });

      NotificationManager.success('Datos de email actualizado.');
      setTimeout(() => dispatch(onChangeLoad(true)), 2000);
    } catch (e) {
      console.error(e.message);
    }
  };

export const updateUser =
  (payload = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch(onChangeLoad(false));
      const { platformName } = getState().platform;
      const { users } = getState().company;
      await database.collection(`${platformName}/data/companiesUsers`).doc(payload.id).update(payload);
      const filterUser = users.filter((user) => user.id !== payload.id);
      const usersArray = [...filterUser, payload];
      dispatch({
        type: companyTypes.GET_USERS,
        users: usersArray,
      });
      dispatch(onChangeLoad(true));
      NotificationManager.success('Usuario Actualizado.');
    } catch (e) {
      console.error(e);
    }
  };

// Este metodo sirve para agreagr a los usuarios de las empresas
export const addUser =
  (payloadOne = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch(onChangeLoad(false));
      const platform = getState().platform;
      const { platformName, platformURL, platformFullName } = getState().platform;
      const payload = payloadOne;
      const password = PasswordGenerator(8);
      const ref = database.collection(`${platformName}/data/companiesUsers`).doc();
      payload.id = ref.id;
      await axios.request({
        url: 'https://us-central1-universia-prod.cloudfunctions.net/company-register',
        method: 'POST',
        data: {
          email: payload.email,
          password,
          segment: platformName.toLowerCase(),
        },
        crossDomain: true,
      });
      await ref.set(payload);
      dispatch({
        type: companyTypes.NEW_USER,
        user: payload,
      });
      await axios.request({
        url: 'https://us-central1-universia-prod.cloudfunctions.net/sendEmailHTML',
        method: 'POST',
        data: bodyEmail(payload.email, password, platformURL, platformFullName, payload.names, platform),
        crossDomain: true,
      });
      dispatch(onChangeLoad(true));
      NotificationManager.success('Usuario Actualizado.');
    } catch (e) {
      console.error(e);
    }
  };
